var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavouriteIconWithBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favourite-icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 24.1709,
    cy: 24.2651,
    r: 23.5,
    fill: "#FEEADB",
    stroke: "#E18F91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.7226 18.0821L24.1706 19.0909L23.6186 18.0821C23.269 17.4432 22.6853 16.5855 21.8258 15.9208C20.94 15.2357 19.9477 14.8944 18.8609 14.8944C15.825 14.8944 13.4724 17.3696 13.4724 20.7923C13.4724 22.6088 14.193 24.164 15.5522 25.804C16.9273 27.4633 18.9072 29.1533 21.3645 31.2473L20.9563 31.7263L21.3645 31.2474L21.3647 31.2476C22.1946 31.9548 23.1379 32.7586 24.1188 33.6165L24.1191 33.6167C24.1329 33.6288 24.151 33.6359 24.1706 33.6359C24.1902 33.6359 24.2083 33.6289 24.2221 33.6168L24.2224 33.6165C25.2027 32.7593 26.1454 31.9558 26.9744 31.2494L26.9762 31.2478L26.9762 31.2478C29.4338 29.1535 31.4138 27.4634 32.789 25.8041C34.1482 24.164 34.8688 22.6088 34.8688 20.7923C34.8688 17.3696 32.5163 14.8944 29.4803 14.8944C28.3936 14.8944 27.4012 15.2357 26.5154 15.9208C25.6559 16.5855 25.0722 17.4432 24.7226 18.0821Z",
    stroke: "#E18F91",
    strokeWidth: 1.25852
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIconWithBorder);
export default __webpack_public_path__ + "static/media/favourite-icon-with-border.9ac39a70360f924c7ea901e369568989.svg";
export { ForwardRef as ReactComponent };